module.exports = __webpack_public_path__ + "img/IT0000481804596.78ccb481.png";